import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const resourceLinks = [
    { label: t('footer_cssbuy_spreadsheet'), href: '/cssbuy-spreadsheet' },
    { label: t('footer_cssbuy_review'), href: '/reviews' },
    { label: t('footer_cssbuy_shipping'), href: '/shipping' },
    { label: t('footer_cssbuy_shipping_cost'), href: '/shipping' },
    { label: t('footer_cssbuy_qc'), href: '/qc' },
    { label: t('footer_cssbuy_warehouse'), href: '/guides' },
    { label: t('footer_cssbuy_coupon'), href: '/guides' },
    { label: t('footer_cssbuy_discount'), href: '/guides' },
    { label: t('footer_cssbuy_legit'), href: '/reviews' },
    { label: t('footer_cssbuy_safety'), href: '/safety' },
  ];

  const legalLinks = [
    { label: t('footer_privacy'), href: '/privacy' },
    { label: t('footer_terms'), href: '/terms' },
    { label: t('footer_disclaimer'), href: '/disclaimer' },
    { label: t('footer_contact'), href: '/contact' },
  ];

  const languageLinks = [
    { label: t('footer_english'), href: '/en' },
    { label: t('footer_portuguese'), href: '/pt-br' },
    { label: t('footer_german'), href: '/de' },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <a href="/" className="font-heading text-xl font-semibold text-foreground-900">
              CSSBuy<span className="text-primary-500">BR</span>
            </a>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              {t('footer_tagline')}
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-primary-500 transition-colors">
                <i className="ri-external-link-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              {t('footer_resources')}
            </h4>
            <ul className="space-y-2">
              {resourceLinks.slice(0, 6).map((link) => (
                <li key={link.href + link.label}>
                  <a href={link.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              {t('footer_legal')}
            </h4>
            <ul className="space-y-2">
              {legalLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Languages */}
          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              {t('footer_languages')}
            </h4>
            <ul className="space-y-2">
              {languageLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            {t('footer_copyright')}
          </p>
          <p className="text-xs text-foreground-500">
            cssbuybr.help
          </p>
        </div>
      </div>
    </footer>
  );
}